import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './personal.module.scss';
import DoctorAvatar from '../../static/images/doctor_avatar.png';
import ArrowRight from '../../static/images/rightArrow.png';
import LaborAgreement from '../../static/images/labor_agreement.png';
import PaySheet from '../../static/images/pay_sheet.png';
import PrivacyIcon from '../../static/images/privacy_icon.png';
import PrivacyAgreement from '../../static/images/privacy_agreement.png';
import PersonalManage from '../../static/images/personal_manage.png';
import PersonalPatient from '../../static/images/personal_patient.png';
import PersonalRecruit from '../../static/images/personal_recruit.png';
import PersonalTool from '../../static/images/personal_tool.png';
import PersonalAccount from '../../static/images/personal_account.png';
import PersonalResetPwd from '../../static/images/personal_reset_pwd.png';
import PersonalInfo from '../../static/images/personal_info.png';
import PersonalBank from '../../static/images/personal_bank.png';
import DoctorTool from '../../static/images_doctor/doctor_tool.png';
import FollowupManage from '../../static/images_doctor/followup_manage.png';
import Settlement from '../../static/images/personal_settlement.png';
import { Modal } from 'antd-mobile';
import { ApiCore } from '../../api/index';
import utils from '../../utils/utils';
const api = new ApiCore();

function Personal(props: any) {

    const [userName, setUserName] = useState('');
    const [userCode, setUserCode] = useState('');
    const [isLogin, setIsLogin] = useState(false); // 登录
    const [hasNews, setHasNews] = useState(props.hasNews);
    const [laborHasNews, setLaborHasNews] = useState(props.laborHasNews);
    const [countHasNews, setCountHasNews] = useState(props.countHasNews);
    const [inWxMiniProgram, setInWxMiniProgram] = useState(false);
    const [isWxMiniLogin, setIsWxMiniLogin] = useState(false);
    const [hasFollowup, setHasFollowup] = useState(props.actionMenus ? props.actionMenus.length > 0 : false); // 是否开启随访相关功能
    const [followupMenus, setFollowupMenus] = useState(props.actionMenus || []); // 是否开启随访相关功能

    useEffect(() => {
        document.title = '个人中心';
        initCondition();
        initName();
        initData();
        return () => {
        }
    }, [])

    const history = useHistory();

    const initCondition = () => {
        let savedUrlParam = localStorage.getItem('OriginUrlParam');
        if (savedUrlParam) {
            let savedOriginUrlParam: any = {};
            try {
                savedOriginUrlParam = JSON.parse(savedUrlParam);
            } catch (error) {
                savedOriginUrlParam = {};
            }
            // 返回至小程序授权、游客登录页
            let _from = savedOriginUrlParam.from;
            if (_from && (_from === 'login' || _from === 'tenant' || _from === 'authGuestIndex')) {
                if (utils.isMiniProgram()) {
                    setIsWxMiniLogin(true);
                }
            }
        }
    }

    const initName = () => {
        let theToken = sessionStorage.getItem('token') || '';
        let tokenInfo: any = {};
        if (theToken) {
            try {
                tokenInfo = JSON.parse(theToken);
            } catch (error) {
                tokenInfo = { userName: '', userCode: '' };
            }
            setUserName(tokenInfo.userName || '');
            setUserCode(tokenInfo.userCode || '');
            setIsLogin(true);
        } else {
            setUserName('暂未登录');
            setUserCode('暂未登录');
            setIsLogin(false);
        }
    }

    // 退出按钮点击
    const toLogOut = () => {
        Modal.alert('退出登录', '确认退出？', [
            { text: '取消', onPress: () => { }, style: 'default' },
            {
                text: '确认', onPress: () => {
                    clearLoginAndLogOut();
                }
            },
        ]);
    }

    // 去登录
    const toLogin = (opstions = {
        clearLoginInfo: false
    }) => {
        if (isWxMiniLogin) {
            let _url = `/pages/authGuestIndex/authGuestIndex?jumpUrlFromH5=${encodeURIComponent(`/pages/login/login`)}&fromUrlFromH5=${encodeURIComponent('/doctor/home?tab=personal')}`;
            if (opstions.clearLoginInfo) {
                _url += '&clearLoginInfo=true';
            }
            (window as any).wx.miniProgram.redirectTo({
                url: _url,
                success: function (e: any) {
                },
                fail: function (e: any) {
                }
            })
        } else {
            history.replace('/login');
        }
    }

    // 切换活动选择租户
    const changeActivity = () => {
        if (isWxMiniLogin) {
            let token: any = sessionStorage.getItem('token');
            let mToken: any = {
                token: ''
            };
            try {
                mToken = JSON.parse(token);
            } catch (error) {
                mToken = {
                    token: ''
                };
            }
            (window as any).wx.miniProgram.redirectTo({
                url: `/pages/authGuestIndex/authGuestIndex?jumpUrlFromH5=${encodeURIComponent(`/pages/tenant/tenant?xAuthToken=${mToken.token}`)}&fromUrlFromH5=${encodeURIComponent('/doctor/home?tab=personal')}`,
                success: function (e: any) {
                },
                fail: function (e: any) {
                }
            })
        }
    }

    /**
     * 请求异常捕获
     */
    const catchFun = (promiseArr: any) => {
        return promiseArr.map((promise: any) => promise.catch((err: any) => Promise.resolve({})))
    }

    const initData = () => {
        // if (utils.isMiniProgram()) { 
        //     setInWxMiniProgram(true);
        // }
        // let token = sessionStorage.getItem('token');
        // // 登录过才获取
        // if (token) {
        //     getViewCount();
        // }
    }

    // 获取服务协议
    const getViewCount = () => {
        let req1 = api.GetAgreementViewCount();
        let req2 = api.GetUserSettlementViewCount();
        let reqList = [req1, req2];
        Promise.all(catchFun(reqList)).then((res: any) => {
            if (res[0].code == 0 || res[1].code == 0) {
                if (res[0].data > 0) {
                    setLaborHasNews(true);
                }
                if (res[1].data > 0) {
                    setCountHasNews(true);
                }
                if (res[0].data > 0 || res[1].data > 0) {
                    props.updateHasNews(true);
                    setHasNews(true);
                }
            }
        });
    }

    // 清除所有信息且退出
    const clearLoginAndLogOut = () => {
        let savedUrlParam = localStorage.getItem('OriginUrlParam');
        sessionStorage.clear();
        localStorage.clear();
        // 需要确保小程序登录来源
        if (savedUrlParam) {
            localStorage.setItem('OriginUrlParam', savedUrlParam);
        }
        toLogin({
            clearLoginInfo: true
        });
    }

    const toLaybor = () => {
        if (!isLogin) {
            toLogin();
        } else {
            // 每次进入，清除筛选状态等缓存
            ['LaborSelectProject', 'LaborSelectStatus',
                'LaborCheckedList', 'LaborPreSignImgUrl',
                'LaborIsMultiSign', 'LaborSigningStatus'].forEach(item => {
                    sessionStorage.removeItem(item);
                });
            // 如果只有一条待签名的页面，直接进入签名页
            api.GetLaborUserAgreementList({
                page: 1,
                pageSize: 10,
                projectCode: '',
                status: ''
            }).then((res: any) => {
                if (res.code == 0) {
                    if (res.data && res.data.rows) {
                        const _rows = res.data.rows;
                        if (_rows.length === 1 && _rows[0].type === 'pre') {
                            const item = _rows[0];
                            history.push(`/doctor/laborAgreement?code=${item.code}&needView=${item.viewFlag}`);
                            return;
                        }
                    }
                }
                history.push(`/doctor/laborService`);
            });
        }
    }

    const toPaySheet = () => {
        if (!isLogin) {
            toLogin();
        } else {
            history.push(`/doctor/paySheet`);
        }
    }

    const toPrivacy = () => {
        history.push(`/doctor/privacy`);
    }

    // 重置密码
    const resetPwd = () => {
        sessionStorage.setItem('ResetPasswordFromPath', '/doctor/home?tab=personal');
        history.push(`/doctor/resetPassword`);
    }

    const toPersonalInfo = () => {
        if (!isLogin) {
            toLogin();
        } else {
            history.push(`/doctor/personalInfo`);
        }
    }

    const toBankInfo = () => {
        if (!isLogin) {
            toLogin();
        } else {
            history.push(`/doctor/bankInfo`);
        }
    }

    const toSettlement = () => {
        if (!isLogin) {
            toLogin();
        } else {
            history.push(`/doctor/settlement`);
        }
    }

    const toFollowupManage = () => {
        props.switchTab && props.switchTab('patient');
    }

    const toDoctorInfo = () => {
        history.push(`/doctor/tools`);
    }

    return (
        <div className={`${styles.personal_content} ${styles.doctor_bg} `}>

            <div className={styles.personal_info}>
                <img className={`${styles.item_img} ${hasFollowup ? styles.head_item_gap : ''}`} src={DoctorAvatar} />
                <div className={`${styles.item_doctor_head} ${hasFollowup ? styles.head_item_gap : ''}`}>
                    <div>{userName}</div>
                    <div></div>
                </div>
                {
                    hasFollowup &&
                    <div className={styles.followup_content} >
                        {
                            followupMenus && followupMenus.map((val: any, key: number) => (
                                <div onClick={val.name === '随访管理' ? toFollowupManage : toDoctorInfo}>
                                    <img src={val.name === '随访管理' ? FollowupManage : DoctorTool} alt="" />
                                    <span className={styles.followup_desc} >{val.name}</span>
                                </div>))
                        }
                    </div>
                }
                {/* <div onClick={toDoctorInfo}>
                        <img src={DoctorTool} alt="" />
                        <span className={styles.followup_desc} >医生工具</span>
                </div> */}
            </div>

            <div className={`${styles.content} ${hasFollowup ? styles.content_has_followup : ''}`}>
                <div className={`${styles.item_gap}`}></div>
                <div className={styles.item}>
                    <img className={styles.item_img} src={PersonalAccount} />
                    <div className={`${styles.item_with_line} ${styles.labor_wrap}`}>
                        <div className={styles.item_with_text}>
                            我的账号
                        </div>
                        <div className={styles.item_text_right}>{userCode}</div>
                    </div>
                    <img className={`${styles.item_arrow} ${styles.item_arrow_hidden}`} src={ArrowRight} />
                </div>
                <div className={`${styles.item}`} onClick={resetPwd}>
                    <img className={styles.item_img} src={PersonalResetPwd} />
                    <div className={`${styles.item_with_line} ${styles.labor_wrap}`}>
                        <div className={styles.item_with_text}>
                            重置密码
                        </div>
                    </div>
                    <img className={styles.item_arrow} src={ArrowRight} />
                </div>
                {/* <div className={`${styles.item}`} onClick={toPersonalInfo}>
                    <img className={styles.item_img} src={PersonalInfo} />
                    <div className={`${styles.item_with_line} ${styles.labor_wrap}`}> 
                        <div> 个人信息 </div>
                    </div>
                    <img className={styles.item_arrow} src={ArrowRight} />
                </div> */}
                {/* <div className={`${styles.item}`} onClick={toBankInfo}>
                    <img className={styles.item_img} src={PersonalBank} />
                    <div> 收款信息 </div>
                    <img className={styles.item_arrow} src={ArrowRight} />
                </div> */}
                <div className={`${styles.item_gap}`}></div>
                <div className={`${styles.item}`} onClick={toSettlement}>
                    <img className={styles.item_img} src={Settlement} />
                    <div> 结算申请 </div>
                    <img className={styles.item_arrow} src={ArrowRight} />
                </div>
                <div className={styles.item} onClick={toLaybor}>
                    <img className={styles.item_img} src={LaborAgreement} />
                    <div className={`${styles.item_with_line} ${styles.labor_wrap}`}>
                        <div className={styles.item_with_text}>
                            服务协议
                            {
                                laborHasNews &&
                                <span className={styles.item_with_dot}></span>
                            }
                        </div>
                        {
                            laborHasNews &&
                            <div className={styles.item_news}>有待查看的服务协议</div>
                            // 新的以及撤销成功的服务协议
                        }
                    </div>
                    <img className={`${styles.item_arrow}`} src={ArrowRight} />
                </div>
                <div className={styles.item} onClick={toPaySheet}>
                    <img className={styles.item_img} src={PaySheet} />
                    <div className={`${styles.labor_wrap} ${styles.item_with_line}`}>
                        <div className={styles.item_with_text}>
                            我的结算单
                            {
                                countHasNews &&
                                <span className={styles.count_item_with_dot}></span>
                            }
                        </div>
                        {
                            countHasNews &&
                            <div className={styles.item_news}>有新的结算单</div>
                        }
                    </div>
                    <img className={styles.item_arrow} src={ArrowRight} />
                </div>
                <div className={styles.item} onClick={toPrivacy}>
                    <img className={styles.item_img} src={PrivacyIcon} />
                    <div className={`${styles.labor_wrap} ${styles.item_with_line}`}>
                        <div className={styles.item_with_text}>
                            {'用户协议&隐私政策'}
                        </div>
                    </div>
                    <img className={styles.item_arrow} src={ArrowRight} />
                </div>
            </div>
            {
                isWxMiniLogin && isLogin &&
                <div className={`${styles.logout_wrap}`} onClick={changeActivity}>
                    <div className={styles.changeActivity}>切换活动</div>
                </div>
            }
            {
                isLogin ?
                    <div className={`${styles.logout_wrap} ${styles.login_bottom}`} onClick={toLogOut}>
                        <div className={styles.logout}>退出登录</div>
                    </div>
                    :
                    <div className={`${styles.logout_wrap} ${styles.login_bottom}`} onClick={() => {
                        toLogin({
                            clearLoginInfo: false
                        })
                    }}>
                        <div className={styles.login}>立即登录 / 注册</div>
                    </div>
            }
        </div>
    )

}

export default Personal;